<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <b-link class="brand-logo">
        <logo />

        <h2 class="brand-text text-primary ml-1">Amini Finance</h2>
      </b-link>

      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1">🔒 فراموشی رمز عبور </b-card-title>

          <validation-observer ref="simpleRules" #default="{ invalid }">
            <b-form
              class="auth-forgot-password-form mt-2"
              @submit.prevent="validationForm"
            >
              <b-form-group label="موبایل یا ایمیل" label-for="login-userName">
                <validation-provider
                  #default="{ errors }"
                  name="userName"
                  rules="required|mobileEmail"
                >
                  <b-form-input
                    autocomplete="on"
                    id="login-userName"
                    v-model.trim="userName"
                    :state="errors.length > 0 ? false : null"
                    name="login-userName"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <div>
                    <small class="text-danger">{{ warn }}</small>
                  </div>
                </validation-provider>
              </b-form-group>
              <b-form-group
                label="کد بازیابی "
                label-for="forgot-password-code"
                v-if="mode !== 'begin'"
              >
                <validation-provider
                  #default="{ errors }"
                  name="code"
                  rules="required|min:6"
                >
                  <b-form-input
                    id="forgot-password-code"
                    v-model.trim="code"
                    :state="errors.length > 0 ? false : null"
                    name="forgot-password-code"
                    :disabled="mode === 'change'"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <template v-if="mode === 'change'">
                <b-form-group
                  label="رمز عبور جدید"
                  label-for="reset-password-new"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Password"
                    vid="Password"
                    rules="required|min:6|password|notArabic"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <b-form-input
                        id="reset-password-new"
                        v-model.trim="password"
                        :type="password1FieldType"
                        :state="errors.length > 0 ? false : null"
                        class="form-control-merge"
                        name="reset-password-new"
                        placeholder="············"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="password1ToggleIcon"
                          @click="togglePassword1Visibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group
                  label-for="reset-password-confirm"
                  label=" تایید رمز عبور جدید"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Confirm Password"
                    :rules="`required|min:6|password|notArabic|confirmed:${password}`"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <b-form-input
                        id="reset-password-confirm"
                        v-model.trim="cPassword"
                        :type="password2FieldType"
                        class="form-control-merge"
                        :state="errors.length > 0 ? false : null"
                        name="reset-password-confirm"
                        placeholder="············"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="password2ToggleIcon"
                          @click="togglePassword2Visibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </template>

              <p class="text-center mt-2" v-if="mode == 'verify'">
                <b-link :disabled="!resendIsOn" @click="resend">
                  <span>ارسال مجدد</span>
                  <span class="mx-1">
                    <vue-countdown
                      :time="60000"
                      @end="onCountdownEnd"
                      v-slot="{ totalSeconds }"
                      >{{ totalSeconds }}
                    </vue-countdown>
                  </span>
                </b-link>
              </p>
              <b-button
                variant="primary"
                block
                type="submit"
                :disabled="invalid"
              >
                {{ submitBtnTitle }}
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{ name: 'auth-login' }">
              <feather-icon icon="ChevronLeftIcon" /> برگشت به صفحه ورود
            </b-link>
          </p>
          <div class="divider my-2"></div>
          <div
            class="auth-footer-btn d-flex justify-content-around align-items-baseline"
          >
            <b-card-text class="text-center mt-2">
              <span class="mr-1">شماره پشتیبانی</span>
              <b-link href="tel:+989191952581">
                <span>09191952581</span>
              </b-link>
            </b-card-text>

            <b-button
              variant="gradient-danger"
              class="btn-icon"
              href="https://instagram.com/amini.finance"
            >
              <feather-icon icon="InstagramIcon" />
            </b-button>
          </div>
        </b-col>
      </b-col>
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" alt="Forgot password V2" />
        </div>
      </b-col>
    </b-row>
    <loader :loading="loading" />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Logo from "@core/layouts/components/Logo.vue";
import Loader from "@/@core/components/loader/Loader.vue";
import {
  BRow,
  BCol,
  BLink,
  BCardTitle,
  BCardText,
  BImg,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BInputGroup,
} from "bootstrap-vue";
import { required, mobileEmail, notArabic } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VueCountdown from "@chenfengyuan/vue-countdown";

export default {
  components: {
    Logo,
    BRow,
    BCol,
    BLink,
    BImg,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BCardTitle,
    BInputGroupAppend,
    BInputGroup,
    BCardText,
    ValidationProvider,
    ValidationObserver,
    Loader,
    VueCountdown,
  },
  data() {
    return {
      userName: "",
      sideImg: require("@/assets/images/login.png"),
      required,
      mobileEmail,
      notArabic,
      cPassword: "",
      password: "",
      loading: false,
      code: "",
      hash: "",
      mode: "begin",
      password1FieldType: "password",
      password2FieldType: "password",
      resendIsOn: false,
      warn: "",
    };
  },

  created() {
    this.mode = "begin";
    this.code = "";
    this.userName = "";
    this.cPassword = "";
    this.password = "";
    this.hash = "";
  },
  watch: {
    userName(val) {
      this.userName = this.p2e(val).toLowerCase();
    },
    code(val) {
      this.code = this.p2e(val).toLowerCase();
    },
    password(val) {
      this.password = this.p2e(val);
    },
    cPassword(val) {
      this.cPassword = this.p2e(val);
    },
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    password1ToggleIcon() {
      return this.password1FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    password2ToggleIcon() {
      return this.password2FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },

    submitBtnTitle() {
      return this.mode === "begin"
        ? "دریافت کد بازیابی رمز عبور"
        : this.mode === "verify"
        ? "تایید کد ارسال شده"
        : "تغییر رمز عبور";
    },
    imgUrl() {
      if (this.$store.state.appConfig.layout.skin === "dark") {
        this.sideImg = require("@/assets/images/login.png");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  methods: {
    onCountdownEnd() {
      this.resendIsOn = true;
    },
    togglePassword1Visibility() {
      this.password1FieldType =
        this.password1FieldType === "password" ? "text" : "password";
    },
    togglePassword2Visibility() {
      this.password2FieldType =
        this.password2FieldType === "password" ? "text" : "password";
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          await this[this.mode]();
        }
      });
    },
    async resend() {
      try {
        const { data } = await this.$http.post("/auth/reset-password/resend", {
          username: this.userName,
        });
        this.resendIsOn = false;
        this.loading = false;
        this.mode = "verify";
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "کد بازیابی با موفقیت ارسال شد",
            icon: "EditIcon",
            variant: "success",
          },
        });
      } catch (err) {
        this.loading = false;
      }
    },
    begin() {
      this.$http
        .post("/auth/reset-password", {
          username: this.userName,
        })
        .then((response) => {
          if (
            response.response &&
            response.response.status &&
            response.response.status == 422
          ) {
            this.warn = response.response.data.errors.username[0];
          }
          if (response.status && response.status == 201) {
            this.mode = "verify";
            this.warn = "";

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "کد بازیابی با موفقیت ارسال شد",
                icon: "EditIcon",
                variant: "success",
              },
            });
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    async verify() {
      try {
        const { data } = await this.$http.post("/auth/reset-password/verify", {
          username: this.userName,
          code: this.code,
        });
        this.hash = data.data.hash;
        this.loading = false;
        this.mode = "change";
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "کد بازیابی تایید شد",
            icon: "EditIcon",
            variant: "success",
          },
        });
      } catch (err) {
        this.loading = false;
      }
    },
    async change() {
      try {
        const { data } = await this.$http.post("/auth/reset-password/change", {
          username: this.userName,
          hash: this.hash,
          password: this.password,
          password_confirmation: this.cPassword,
        });
        this.loading = false;
        this.$router.replace("/login").then(() => {
          this.$toast(
            {
              component: ToastificationContent,

              props: {
                title: "رمز عبور با موفقیت تغییر کرد",
                icon: "CoffeeIcon",
                variant: "success",
              },
            },
            { position: "bottom-right" }
          );
        });
      } catch (err) {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
